import {SkeletonBrickTheme} from '@Components/skeleton-brick';
import {assertNever} from '@Utils/assert-never.util';
import {SkeletonMode} from '@Components/ai-chat-window/lib/skeleton.types';

export function resolveSkeletonBrickTheme(mode: SkeletonMode): SkeletonBrickTheme {
  switch (mode) {
    case SkeletonMode.GENERATING:
      return SkeletonBrickTheme.AI_ROTATING_GRADIENT;
    case SkeletonMode.LOADING:
      return SkeletonBrickTheme.LIGHT;
    default:
      return assertNever(mode);
  }
}

export function parseSkeletonMode(value: unknown): SkeletonMode {
  if (value === SkeletonMode.LOADING) {
    return SkeletonMode.LOADING;
  }

  return SkeletonMode.GENERATING;
}
